var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../../assets/images/empty.png"),"alt":""}})])
}]

export { render, staticRenderFns }